import { getAccessToken } from '../authentication/supabaseService';
import { AlternativeLinkCommitRequest, AlternativeLinkCommitResponse, AlternativeLinkDryRunRequest, AlternativeLinkPlan, AlternativeLinkPreview, AlternativeLinkPreviewRequest } from './alternativeLinkTypes';

async function post<T>(action: string, body: { selectedProductKeys?: string[] }, signal?: AbortSignal): Promise<T> {
  const token = await getAccessToken();
  const response = await fetch(`/api/costprice/${body.selectedProductKeys ? 'unlinked-alternatives' : 'alternatives-link'}/${action}`, {
    method: 'POST', signal,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`Alternatives ${action}: HTTP ${response.status}`);
  return response.json();
}

export const analyzeAlternativeLinks = (request: AlternativeLinkDryRunRequest, signal?: AbortSignal) => post<AlternativeLinkPlan>('dry-run', request, signal);
export const previewAlternativeLinks = (request: AlternativeLinkPreviewRequest, signal?: AbortSignal) => post<AlternativeLinkPreview>('preview', request, signal);
// A commit can finish after the drawer closes. Do not mistake aborting a read for rollback.
export const commitAlternativeLinks = (request: AlternativeLinkCommitRequest) => post<AlternativeLinkCommitResponse>('commit', request);
